// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { SavedProvider } from './context/SavedContext';
import { CompareProvider } from './context/CompareContext';
import { ToastProvider } from './context/ToastContext'; // <--- ENSURE THIS IS HERE

// PWA service worker registration (PRODUCTION-ONLY — in dev it actively
// unregisters any old service worker and clears its caches instead).
import { register as registerSW } from './serviceWorkerRegistration';

// --- PWA INSTALL PROMPT: capture early ---
// Chrome fires `beforeinstallprompt` before React mounts — stash it on window
// so the Install button can use it whenever it renders.
window.__deferredInstallPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__deferredInstallPrompt = e;
  window.dispatchEvent(new Event('pwa-installable'));
});
window.addEventListener('appinstalled', () => {
  window.__deferredInstallPrompt = null;
  window.dispatchEvent(new Event('pwa-installed'));
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastProvider> {/* <--- THIS WRAPPER IS REQUIRED FOR TOASTS TO WORK */}
      <AuthProvider>
        <CartProvider>
          <SavedProvider>
            <CompareProvider>
              <App />
            </CompareProvider>
          </SavedProvider>
        </CartProvider>
      </AuthProvider>
    </ToastProvider>
  </React.StrictMode>
);

reportWebVitals();

// Register the PWA service worker (no-op + cleanup in dev, real in prod).
registerSW();
